export { default } from "./TableManagementEdit";
